import React, { useCallback } from 'react';
import PhaseTitle from '../composants/PhaseTitle';

const SessionTile = React.memo(({ session, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(session.session_id);
  }, [onClick, session.session_id]);

  let additionalInfo = '';
  
  try {
    const jsonParametres = JSON.parse(session.parametres || '{}');

    if (session.type === 'plan') {
      const parties = jsonParametres.parties || 0;
      const sousparties = jsonParametres.sousparties || 0;
      additionalInfo = `Plan (${parties} parties, ${sousparties} sous-parties)`;
    } else if (session.type === 'redaction') {
      const phases = jsonParametres.phases || 0;
      if (phases === 0) {
        additionalInfo = 'Phases illimitées';
      } else if (phases === 1) {
        additionalInfo = 'Phase unique';
      } else {
        additionalInfo = `${phases} phases`;
      }
    }
  } catch (e) {
    additionalInfo = session.type === 'plan' ? 'Plan' : 'Rédaction';
  }

  const getPhaseStatusIcon = () => {
    if (session.phase === 0) return '⏳';
    if (session.closed) return '✅';
    return session.phase % 2 !== 0 ? '✍️' : '⭐';
  };

  const getPhaseStatusColor = () => {
    if (session.phase === 0) return 'status-waiting';
    if (session.closed) return 'status-completed';
    return 'status-active';
  };

  const getSessionTypeIcon = () => {
    if (session.type === 'plan') return '📊';
    try {
      const jsonParametres = JSON.parse(session.parametres || '{}');
      return jsonParametres.phases === 1 ? '📄' : '🔄';
    } catch (e) {
      return '📄';
    }
  };

  return (
    <div className="session-tile" onClick={handleClick}>
      <div className="session-tile-header">
        <div className="session-id">
          <span className="session-icon">📌</span>
          <span className="session-code">{session.session_id}</span>
          {session.password && <span className="password-icon">🔒</span>}
        </div>
        <div className={`session-status ${getPhaseStatusColor()}`}>
          <span className="status-icon">{getPhaseStatusIcon()}</span>
        </div>
      </div>
      
      <div className="session-tile-body">
        <h3 className="session-title">{session.sujet}</h3>
        
        <div className="session-info">
          <div className="session-type">
            <span className="type-icon">{getSessionTypeIcon()}</span>
            <span className="type-text">{additionalInfo}</span>
          </div>
          
          <div className="session-phase">
            <PhaseTitle 
              phase={session.phase} 
              type={session.type} 
              parametres={session.parametres} 
            />
          </div>
        </div>
      </div>
      
      <div className="session-tile-footer">
        <span className="join-hint">Cliquer pour rejoindre</span>
      </div>
    </div>
  );
}, (prevProps, nextProps) => {
  return JSON.stringify(prevProps.session) === JSON.stringify(nextProps.session);
});

SessionTile.displayName = 'SessionTile';

export default SessionTile;